// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClassTooltipContent_wrapper__2Lx3X","content":"ClassTooltipContent_content__1RaXP"};